import { Flex } from "@similarweb/ui-components/foundations";

import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";

import { METRIC_CARDS_KEY_PREFIX } from "./constants";

interface IMetricCardEmptyStateProps {
    /** i18n key for the empty-state title. Defaults to the Demand Analysis copy. */
    titleKey?: string;
    /** i18n key for the empty-state subtitle. Defaults to the Demand Analysis copy. */
    subtitleKey?: string;
}

export const MetricCardEmptyState = ({
    titleKey = `${METRIC_CARDS_KEY_PREFIX}.nodata.title`,
    subtitleKey = `${METRIC_CARDS_KEY_PREFIX}.nodata.subtitle`,
}: IMetricCardEmptyStateProps = {}) => (
    <Flex
        flex="1"
        padding="24px"
        justifyContent="center"
        alignItems="center"
        data-automation="search-trends-metric-card-empty"
    >
        <NoDataLandscape
            title={titleKey}
            subtitle={subtitleKey}
        />
    </Flex>
);
